<template>
  <v-flex
    id="previous-editions"
    class="question"
  >
    <h2 class="header">
      {{ getPreviousEditionsQuestions.label }}
    </h2>
    <ul class="questions-list">
      <li v-if="getPreviousEditionsQuestions.hasOwnProperty('help_received')">
        <p
          class="header mb-1 required"
          :class="{ required: getPreviousEditionsQuestions.help_received.required }"
        >
          {{ getPreviousEditionsQuestions.help_received.label }}
        </p>
        <ConfirmButtons
          v-model="helpReceived"
          v-validate="{ required: getPreviousEditionsQuestions.help_received.required }"
          class="mb-4"
          string
          :error-messages="errors.collect('helpReceived')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'helpReceived'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="helpReceived === 'yes' && getPreviousEditionsQuestions.hasOwnProperty('help_amount')"
      >
        <p
          class="header mb-1"
          :class="{ required: getPreviousEditionsQuestions.help_amount.required }"
        >
          {{ getPreviousEditionsQuestions.help_amount.label }}
        </p>
        <CounterButtons
          v-model="helpAmount"
          v-validate="{ requiredMoreThanZero: getPreviousEditionsQuestions.help_amount.required }"
          class="mb-4"
          :error-messages="errors.collect('helpAmount')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'helpAmount'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="
          helpReceived === 'yes' &&
            getPreviousEditionsQuestions.hasOwnProperty('how_do_you_remember')
        "
      >
        <p
          class="header"
          :class="{ required: getPreviousEditionsQuestions.how_do_you_remember.required }"
        >
          {{ getPreviousEditionsQuestions.how_do_you_remember.label }}
        </p>
        <div class="mb-3">
          <v-textarea
            v-model="howDoYouRemember"
            v-validate="{
              ...requiredRegularField(getPreviousEditionsQuestions.how_do_you_remember.required)
            }"
            :error-messages="errors.collect('howDoYouRemember')"
            :data-vv-as="$t('label.question')"
            :data-vv-name="'howDoYouRemember'"
            :required="getPreviousEditionsQuestions.how_do_you_remember.required"
            :placeholder="$t('sheet.enter_text')"
            auto-grow
            :disabled="readOnly"
          />
        </div>
      </li>
      <li
        v-if="
          helpReceived === 'yes' && getPreviousEditionsQuestions.hasOwnProperty('what_has_changed')
        "
      >
        <p
          class="header"
          :class="{ required: getPreviousEditionsQuestions.what_has_changed.required }"
        >
          {{ getPreviousEditionsQuestions.what_has_changed.label }}
        </p>
        <div class="mb-3">
          <v-textarea
            v-model="whatHasChanged"
            v-validate="{
              ...requiredRegularField(getPreviousEditionsQuestions.what_has_changed.required)
            }"
            :error-messages="errors.collect('whatHasChanged')"
            :data-vv-as="$t('label.question')"
            :data-vv-name="'whatHasChanged'"
            :required="getPreviousEditionsQuestions.what_has_changed.required"
            :placeholder="$t('sheet.enter_text')"
            auto-grow
            :disabled="readOnly"
          />
        </div>
      </li>
      <li
        v-if="
          helpReceived === 'yes' && getPreviousEditionsQuestions.hasOwnProperty('has_impact_change')
        "
      >
        <p
          class="header mb-1"
          :class="{ required: getPreviousEditionsQuestions.has_impact_change.required }"
        >
          {{ getPreviousEditionsQuestions.has_impact_change.label }}
        </p>
        <BaseRadio
          v-if="isCurrentEdition || Number.isInteger(hasImpactChange)"
          v-model="hasImpactChange"
          :required="getPreviousEditionsQuestions.has_impact_change.required"
          name="hasImpactChange"
          :values="hasImpactChangeResource"
          value-key="id"
          label-key="description"
          :disabled="readOnly"
        />
        <ConfirmButtons
          v-else
          v-model="hasImpactChange"
          v-validate="{ required: getPreviousEditionsQuestions.has_impact_change.required }"
          class="mb-4"
          string
          :error-messages="errors.collect('hasImpactChange')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'hasImpactChange'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="
          helpReceived === 'yes' &&
            hasImpactChange === 'yes' &&
            getPreviousEditionsQuestions.hasOwnProperty('impact_on_life')
        "
      >
        <p
          class="header custom lA"
          :class="{ required: getPreviousEditionsQuestions.impact_on_life.required }"
        >
          {{ getPreviousEditionsQuestions.impact_on_life.label }}
        </p>
        <div class="mb-3">
          <v-textarea
            v-model="impactOnLife"
            v-validate="{
              ...requiredRegularField(getPreviousEditionsQuestions.impact_on_life.required)
            }"
            :error-messages="errors.collect('impactOnLife')"
            :data-vv-as="$t('label.question')"
            :data-vv-name="'impactOnLife'"
            :required="getPreviousEditionsQuestions.impact_on_life.required"
            :placeholder="$t('sheet.enter_text')"
            auto-grow
            :disabled="readOnly"
          />
        </div>
      </li>
      <li
        v-if="
          helpReceived === 'yes' &&
            getPreviousEditionsQuestions.hasOwnProperty('attempt_to_get_out_of_situation')
        "
      >
        <p
          class="header mb-1"
          :class="{
            required: getPreviousEditionsQuestions.attempt_to_get_out_of_situation.required
          }"
        >
          {{ getPreviousEditionsQuestions.attempt_to_get_out_of_situation.label }}
          <span
            v-if="!getPreviousEditionsQuestions.attempt_to_get_out_of_situation.required"
            class="optional-text"
          >
            {{ $t('message.optional') | brackets }}</span>
        </p>
        <ConfirmButtons
          v-if="isCurrentEdition || typeof attemptToGetOutOfSituation === 'string'"
          v-model="attemptToGetOutOfSituation"
          v-validate="{
            required: getPreviousEditionsQuestions.attempt_to_get_out_of_situation.required
          }"
          class="mb-4"
          string
          :error-messages="errors.collect('attemptToGetOutOfSituation')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'attemptToGetOutOfSituation'"
          :disabled="readOnly"
        />
        <v-radio-group
          v-else
          v-model="attemptToGetOutOfSituation"
          v-validate="{
            required: getPreviousEditionsQuestions.attempt_to_get_out_of_situation.required
          }"
          :disabled="readOnly"
          :error-messages="errors.collect('attemptToGetOutOfSituation')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'attemptToGetOutOfSituation'"
          :required="getPreviousEditionsQuestions.attempt_to_get_out_of_situation.required"
        >
          <v-radio
            v-for="(res, index) in resource"
            :key="index"
            off-icon=""
            on-icon=""
            :value="res.id"
            :label="res.description"
          />
        </v-radio-group>
      </li>
      <SheetQuestion
        v-if="
          attemptToGetOutOfSituation === 'yes' &&
            helpReceived === 'yes' &&
            !!attemptToGetOutOfSituation &&
            getPreviousEditionsQuestions.hasOwnProperty('attempt_to_get_out_of_situation_reason')
        "
        :label="getPreviousEditionsQuestions.attempt_to_get_out_of_situation_reason.label"
        :required="getPreviousEditionsQuestions.attempt_to_get_out_of_situation_reason.required"
        started
        list-sign="lA"
      >
        <v-textarea
          key="attemptToGetOutOfSituationReason"
          v-model="attemptToGetOutOfSituationReason"
          v-validate="{
            ...requiredRegularField(
              getPreviousEditionsQuestions.attempt_to_get_out_of_situation_reason.required
            )
          }"
          :error-messages="errors.collect('attemptToGetOutOfSituationReason')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'attemptToGetOutOfSituationReason'"
          :required="getPreviousEditionsQuestions.attempt_to_get_out_of_situation_reason.required"
          :placeholder="$t('sheet.enter_text')"
          auto-grow
          :disabled="readOnly"
        />
      </SheetQuestion>
      <SheetQuestion
        v-if="
          attemptToGetOutOfSituation === 'no' &&
            helpReceived === 'yes' &&
            !!attemptToGetOutOfSituation &&
            getPreviousEditionsQuestions.hasOwnProperty('get_out_of_situation_reason_explain')
        "
        :label="getPreviousEditionsQuestions.get_out_of_situation_reason_explain.label"
        :required="getPreviousEditionsQuestions.get_out_of_situation_reason_explain.required"
        started
        list-sign="lB"
      >
        <v-textarea
          key="getOutOfSituationReasonExplain"
          v-model="getOutOfSituationReasonExplain"
          v-validate="{
            ...requiredRegularField(
              getPreviousEditionsQuestions.get_out_of_situation_reason_explain.required
            )
          }"
          :error-messages="errors.collect('getOutOfSituationReasonExplain')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'getOutOfSituationReasonExplain'"
          :required="getPreviousEditionsQuestions.get_out_of_situation_reason_explain.required"
          :placeholder="$t('sheet.enter_text')"
          auto-grow
          :disabled="readOnly"
        />
      </SheetQuestion>
    </ul>
  </v-flex>
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';
import CounterButtons from '@/components/widgets/sheet/CounterButtons';
import BaseRadio from '../../../widgets/BaseRadio.vue';
import SheetQuestion from '../../SheetQuestion.vue';

import filters from '@/constants/filters';
import validationRules from '@/constants/validationRules';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';

import { mapGetters } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
    getterType: 'sheet/getPreviousEditionsField',
    mutationType: 'sheet/updatePreviousEditionsField'
});

export default {
    name: 'PreviousEditions',
    components: {
        ConfirmButtons,
        CounterButtons,
        BaseRadio,
        SheetQuestion
    },
    filters: {
        ...filters
    },
    mixins: [sheetValidationRules, sheetResourcesGetter],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        },
        isCurrentEdition: {
            default: true,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules,
            getOutOfSituationReason: ''
        };
    },
    computed: {
        ...mapFields([
            'helpReceived',
            'helpAmount',
            'howDoYouRemember',
            'whatHasChanged',
            'hasImpactChange',
            'impactOnLife',
            'attemptToGetOutOfSituation',
            'attemptToGetOutOfSituationReason',
            'getOutOfSituationReasonExplain'
        ]),
        ...mapGetters('sheet', ['getPreviousEditionsQuestions']),
        resource () {
            return this.getResources(this.getPreviousEditionsQuestions.attempt_to_get_out_of_situation);
        },
        hasImpactChangeResource () {
            return this.getResources(this.getPreviousEditionsQuestions.has_impact_change);
        }
    },
    watch: {
        attemptToGetOutOfSituation: {
            immediate: true,
            handler (val) {
                this.getOutOfSituationReason =
          val === 'yes'
              ? this.getPreviousEditionsQuestions.attempt_to_get_out_of_situation_reason.label
              : this.getPreviousEditionsQuestions.get_out_of_situation_reason_explain.label;
                if (val == null) {
                    this.getOutOfSituationReasonExplain = null;
                    this.attemptToGetOutOfSituationReason = null;
                }
                if (val === 'yes') {
                    this.getOutOfSituationReasonExplain = null;
                }
                if (val === 'no') {
                    this.attemptToGetOutOfSituationReason = null;
                }
            }
        },
        helpReceived (val) {
            if (val === 'no') {
                this.helpAmount = 0;
                this.howDoYouRemember = null;
                this.whatHasChanged = null;
                this.hasImpactChange = null;
                this.impactOnLife = null;
                this.attemptToGetOutOfSituation = null;
                this.attemptToGetOutOfSituationReason = null;
                this.getOutOfSituationReasonExplain = null;
            }
        },
        hasImpactChange (val) {
            if (val === 'no') {
                this.impactOnLife = null;
            }
        }
    }
};
</script>

<style scoped>
.temp-height {
  height: 400px;
}
</style>
